module.exports = __webpack_public_path__ + "media/images/logo-signature-5ab695ab770187796cc4a589fe6ebd21.svg";